import { useEffect, useState } from "react";

export default function EventsHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className="relative w-full h-[50vh] min-h-[400px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://framerusercontent.com/images/G7vOiWCtilCao3EPm8ioIuenxg.png"
          alt="PWA Events"
          className="w-full h-full object-cover object-center transition-transform duration-[6000ms] ease-out"
          style={{ transform: loaded ? "scale(1)" : "scale(1.06)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" />
        {/* Decorative corner */}
        <div className="absolute bottom-0 right-0 w-80 h-80 border-r border-b border-orange-500/12 pointer-events-none" />
      </div>

      {/* Glow */}
      <div className="absolute bottom-0 left-1/3 w-64 h-32 bg-orange-500/12 blur-3xl pointer-events-none" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-14 md:pb-20 px-6 md:px-16 lg:px-24 w-full">
        <div
          className={`inline-block bg-orange-500 text-white font-condensed font-bold text-xs uppercase tracking-widest px-3 py-1 mb-4 w-fit anim-hidden ${loaded ? "animate-fade-in-left" : ""}`}
        >
          Live Events
        </div>
        <h1
          className={`font-condensed font-black text-white uppercase leading-none tracking-tight text-5xl md:text-7xl anim-hidden ${loaded ? "animate-fade-in-left delay-100" : ""}`}
        >
          Events
        </h1>
        <p
          className={`text-white/70 mt-3 text-sm md:text-base max-w-lg anim-hidden ${loaded ? "animate-fade-in-up delay-200" : ""}`}
        >
          Catch the action live. Upcoming shows, past results, and everything in between.
        </p>
      </div>
    </header>
  );
}
